import { MISSING } from 'actions/shared.types';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const fromActionTypeToArray = (at) => [
  fromAnyToTrimmed(at?.init) || MISSING.init,
  fromAnyToTrimmed(at?.pass) || MISSING.pass,
  fromAnyToTrimmed(at?.fail) || MISSING.fail,
  fromAnyToTrimmed(at?.done) || MISSING.done,
];

export default fromActionTypeToArray;
